export const hasKitsAndFavorites = [
    {
        id: 82927,
        name: "Favorites",
        slug: "favorites",
        is_public: true,
        is_locked: false,
        user_owned: true,
        icon_ids: [
            1499,
            3030,
            4173,
            4258,
            4963,
            5466,
            6457,
            8156,
            8218,
            8231,
            9383,
            9454,
            9786,
            9962,
            11220,
            15208,
            17164,
            18486,
            18876,
            33261,
            38239,
            38248
        ]
    },
    {
        id: 344481,
        name: "A cool kit",
        slug: "a-cool-kit",
        is_public: true,
        is_locked: false,
        user_owned: true,
        icon_ids: []
    },
    {
        id: 345289,
        name: "I love this",
        slug: "i-love-this",
        is_public: false,
        is_locked: false,
        user_owned: true,
        icon_ids: [5582]
    },
    {
        id: 123456,
        name:
            "Awesome kit name that is really really really ridiculously good-looking",
        slug:
            "awesome-kit-name-that-is-really-really-really-ridiculously-good-looking",
        is_public: false,
        is_locked: false,
        user_owned: true,
        icon_ids: [5582]
    }
];

export const hasNoKitsAndFavorites = [
    {
        id: 82927,
        name: "Favorites",
        slug: "favorites",
        is_public: true,
        is_locked: false,
        user_owned: true,
        icon_ids: [
            1499,
            3030,
            4173,
            4258,
            4963,
            5466,
            6457,
            8156,
            8218,
            8231,
            9383,
            9454,
            9786,
            9962,
            11220,
            15208,
            17164,
            18486,
            18876,
            33261,
            38239,
            38248
        ]
    }
];
